export enum PAYMENTS_METHODS {
    METHOD_KLARNA = 'klarna',
    METHOD_CREDIT_CARD = 'ms_paymentsos',
    METHOD_STRIPE = 'stripe',
}

export const KLARNA_CONTAINER_ID = 'klarna-payments-container';

export const CREATE_KLARNA_SESSION_URL = 'payment/klarna/session';

export const KLARNA_SDK_URL = 'https://x.klarnacdn.net/kp/lib/v1/api.js';

export const PAYMENT_OS_SCRIPT_SRC = 'https://js.paymentsos.com/v3/latest/secure-fields.min.js';

export const STRIPE_SCRIPT_SRC = 'https://js.stripe.com/v3/';
